import { RichText } from 'prismic-reactjs'

export default (data) => {
  if (!data) return ''
  if ('string' === typeof data) return data
  if (data.text) return data.text
  if (Array.isArray(data)) return RichText.asText(data)
  return ''
}
